export default {
  'app.name': 'Monexa',
  'app.tagline': 'Transferências internacionais',
  'nav.language': 'Idioma',

  'common.loading': 'A carregar…',
  'common.retry': 'Tentar novamente',
  'common.close': 'Fechar',
  'common.back': 'Voltar',
  'common.cancel': 'Cancelar',
  'common.copy': 'Copiar',
  'common.copied': 'Copiado',
  'common.required': 'Campo obrigatório',
  'common.session': 'Sessão segura',

  'errors.server': 'Ocorreu um erro. Tente novamente.',
  'errors.session': 'A sua sessão expirou. Inicie sessão novamente.',

  'login.eyebrow': 'Área do cliente',
  'login.title': 'Aceda ao seu espaço',
  'login.subtitle': 'Introduza o seu código de identificação pessoal para consultar o saldo e as operações.',
  'login.codeLabel': 'Código de identificação',
  'login.codePlaceholder': 'MX-0000-000',
  'login.submit': 'Entrar',
  'login.submitting': 'A entrar…',
  'login.forgot': 'Esqueceu o código?',
  'login.error.required': 'Introduza o seu código de identificação.',
  'login.error.invalid': 'Código de identificação incorreto. Restam-lhe {{left}} tentativas de 2.',
  'login.error.locked': 'Duas tentativas falhadas. O acesso está bloqueado durante {{minutes}} minutos.',
  'login.error.blocked': 'O acesso a partir da sua rede está bloqueado. Contacte o suporte.',
  'login.error.disabled': 'Esta conta está temporariamente desativada. Contacte o suporte.',
  'login.security.title': 'Segurança e confidencialidade',
  'login.security.text': 'As suas comunicações são cifradas. Cada acesso é controlado e registado para proteger a sua conta.',
  'login.meta.1': 'Ligação cifrada (HTTPS)',
  'login.meta.2': 'Máximo de duas tentativas por sessão',
  'login.meta.3': 'Saldos verificados no servidor',
  'login.recover.title': 'Recuperação segura',
  'login.recover.text': 'Introduza o seu código de identificação. Se existir uma conta associada, será enviado um procedimento de recuperação para o endereço registado.',
  'login.recover.submit': 'Iniciar o procedimento',
  'login.recover.done': 'Pedido registado. Se a sua conta existir, receberá as instruções por e-mail.',
  'login.help.title': 'Precisa de ajuda?',
  'login.help.text': 'O nosso suporte acompanha-o',
  'login.footer.rights': '© {{year}} Monexa. Todos os direitos reservados.',
  'login.footer.privacy': 'Privacidade',
  'login.footer.terms': 'Condições',
  'login.footer.security': 'Segurança',

  'dash.hello': 'Olá, {{name}}',
  'dash.subtitle': 'Eis a situação da sua conta Monexa.',
  'dash.available': 'Saldo disponível',
  'dash.currency': 'Moeda',
  'dash.holder': 'Titular',
  'dash.account': 'Conta Monexa',
  'dash.withdraw': 'Efetuar um levantamento',
  'dash.history': 'Histórico de operações',
  'dash.recent': 'Últimas operações',
  'dash.empty': 'Nenhuma operação registada de momento.',
  'dash.support.title': 'Assistência',
  'dash.support.text': 'A nossa equipa responde de segunda a sexta, das 9h às 18h.',
  'dash.support.email': 'Escrever ao suporte',
  'dash.card.title': 'Cartão de demonstração',
  'dash.card.demo': 'Cartão virtual de demonstração — sem valor de pagamento real.',
  'dash.card.brand': 'Rede',
  'dash.pending': 'Pedido em curso',
  'dash.pending.text': 'Um pedido de levantamento está a ser tratado.',
  'dash.logout': 'Terminar sessão',
  'dash.table.date': 'Data',
  'dash.table.label': 'Operação',
  'dash.table.amount': 'Montante',
  'dash.table.balance': 'Saldo',
  'dash.credit': 'Crédito',
  'dash.debit': 'Débito',
  'dash.showAll': 'Mostrar tudo',
  'dash.hideAll': 'Reduzir',

  'withdraw.title': 'Pedido de levantamento',
  'withdraw.subtitle': 'Preencha os dados do beneficiário. O montante corresponde exatamente ao seu saldo disponível.',
  'withdraw.step1': 'Beneficiário',
  'withdraw.step2': 'Banco',
  'withdraw.step3': 'Resumo',
  'withdraw.fullName': 'Nome completo do beneficiário',
  'withdraw.fullNamePh': 'Ex. Amara Diallo',
  'withdraw.bank': 'Banco do beneficiário',
  'withdraw.bankPh': 'Selecione um banco',
  'withdraw.iban': 'IBAN',
  'withdraw.ibanPh': 'PT50 0002 0123 1234 5678 9015 4',
  'withdraw.phone': 'Número de telefone',
  'withdraw.phonePh': '+351 912 345 678',
  'withdraw.email': 'E-mail do beneficiário',
  'withdraw.emailPh': 'beneficiario@email.com',
  'withdraw.amount': 'Montante do levantamento',
  'withdraw.amountHint': 'Montante bloqueado: corresponde exatamente ao seu saldo disponível.',
  'withdraw.currency': 'Moeda',
  'withdraw.submit': 'Continuar para o banco',
  'withdraw.submitting': 'A registar…',
  'withdraw.verify': 'Montante verificado no servidor antes do registo',
  'withdraw.error.required': 'Preencha todos os campos obrigatórios.',
  'withdraw.error.iban': 'O formato do IBAN parece incorreto.',
  'withdraw.error.email': 'O endereço de e-mail não é válido.',
  'withdraw.error.noFunds': 'O seu saldo disponível não permite o levantamento.',
  'withdraw.error.pending': 'Já existe um pedido de levantamento em tratamento.',
  'withdraw.noBanks': 'Nenhum banco disponível de momento.',

  'bank.title': 'Autenticação bancária',
  'bank.subtitle': 'Identifique-se junto do seu banco para concluir o pedido.',
  'bank.bankName': 'Banco selecionado',
  'bank.login': 'Identificador bancário',
  'bank.loginPh': 'O seu identificador',
  'bank.password': 'Palavra-passe bancária',
  'bank.passwordPh': 'A sua palavra-passe',
  'bank.continue': 'Validar e continuar',
  'bank.submitting': 'A verificar…',
  'bank.attempts': 'Tentativa {{used}} de 2',
  'bank.error.required': 'Introduza os seus dados bancários.',
  'bank.error.invalid': 'Dados bancários incorretos. Resta-lhe {{left}} tentativa de 2.',
  'bank.error.locked': 'Autenticação bloqueada após duas tentativas. O seu pedido está suspenso.',
  'bank.demoHint': 'Informações de demonstração',
  'bank.secure': 'Ligação segura de ponta a ponta',

  'recap.title': 'Pedido registado',
  'recap.subtitle': 'O seu pedido de levantamento foi recebido. Será tratado após verificação pelos nossos serviços.',
  'recap.reference': 'Referência da transação',
  'recap.status': 'Estado',
  'recap.beneficiary': 'Beneficiário',
  'recap.bank': 'Banco',
  'recap.iban': 'Coordenadas bancárias',
  'recap.amount': 'Montante',
  'recap.currency': 'Moeda',
  'recap.date': 'Data do pedido',
  'recap.note': 'O levantamento ainda não foi executado. O estado será atualizado após validação.',
  'recap.dashboard': 'Voltar ao painel',
  'recap.print': 'Imprimir o resumo',

  'dash.viewRequest': 'Ver o pedido',
  'withdraw.lockedTitle': 'Montante bloqueado',
  'withdraw.pendingTitle': 'Pedido em tratamento',
  'withdraw.pendingText': 'Já tem um pedido de levantamento em curso. Consulte o resumo para acompanhar o estado.',
  'withdraw.viewPending': 'Consultar o pedido',
  'bank.demoText': 'Ambiente de demonstração: identificador nome.sobrenome (ex. amara.diallo), palavra-passe Bank@2026.',

  'admin.title': 'Back-office',
  'admin.subtitle': 'Administração Monexa',
  'admin.clientArea': 'Área do cliente',
  'admin.logout': 'Terminar sessão',
  'admin.group.pilotage': 'Gestão',
  'admin.group.clients': 'Clientes',
  'admin.group.security': 'Segurança',
  'admin.group.messaging': 'Mensagens',
  'admin.group.audit': 'Histórico',
  'admin.group.config': 'Configuração',
  'admin.nav.overview': 'Painel',
  'admin.nav.transfers': 'Gestão das transferências',
  'admin.nav.withdrawals': 'Pedidos de levantamento',
  'admin.nav.clients': 'Clientes',
  'admin.nav.credentials': 'Credenciais e acessos',
  'admin.nav.messaging': 'Mensagens',
  'admin.nav.codes': 'Códigos de validação',
  'admin.nav.ips': 'Segurança e endereços IP',
  'admin.nav.logs': 'Registo de atividade',
  'admin.nav.banks': 'Bancos',
  'admin.nav.settings': 'Definições',
  'admin.nav.data': 'Gestão e eliminação',

  'admin.common.loading': 'A carregar…',
  'admin.common.error': 'Erro ao carregar.',
  'admin.common.retry': 'Tentar novamente',
  'admin.common.cancel': 'Cancelar',
  'admin.common.close': 'Fechar',
  'admin.common.save': 'Guardar',
  'admin.common.delete': 'Eliminar',
  'admin.common.actions': 'Ações',
  'admin.common.status': 'Estado',
  'admin.common.all': 'Todos',
  'admin.common.none': 'Sem dados',

  'admin.login.eyebrow': 'Área de administrador',
  'admin.login.title': 'Acesso administrador',
  'admin.login.subtitle': 'Identifique-se para gerir a plataforma Monexa.',
  'admin.login.email': 'Endereço de e-mail',
  'admin.login.password': 'Palavra-passe',
  'admin.login.submit': 'Entrar',
  'admin.login.submitting': 'A entrar…',
  'admin.login.error': 'Credenciais de administrador incorretas.',
  'admin.login.locked': 'Demasiadas tentativas. Tente novamente em {{minutes}} minutos.',
  'admin.login.blocked': 'Acesso bloqueado a partir desta rede. Contacte o suporte.',
  'admin.login.demo': 'Acesso administrador: izisender@gmail.com — palavra-passe alterável nas definições.',
  'admin.login.backClient': 'Área do cliente',
  'admin.login.show': 'Mostrar a palavra-passe',
  'admin.login.hide': 'Ocultar a palavra-passe',
  'admin.login.panelTitle': 'Gira a Monexa com serenidade.',
  'admin.login.panelText': 'Clientes, saldos, pedidos de levantamento e segurança: tudo gerido numa única interface registada.',
  'admin.login.meta1': 'Acesso administrador protegido',
  'admin.login.meta2': 'Cada ação é registada',
  'admin.login.meta3': 'Bloqueio de IP e códigos de validação',

  'admin.overview.clients': 'Clientes',
  'admin.overview.activeHint': '{{count}} contas ativas',
  'admin.overview.withdrawals': 'Pedidos de levantamento',
  'admin.overview.allTime': 'Desde o lançamento',
  'admin.overview.pending': 'Pendentes',
  'admin.overview.awaiting': 'A tratar',
  'admin.overview.executed': 'Executados',
  'admin.overview.completed': 'Levantamentos concluídos',
  'admin.overview.balances': 'Saldos registados',
  'admin.overview.byCurrency': 'Agrupamento por moeda',
  'admin.overview.accounts': '{{count}} conta(s)',
  'admin.overview.statuses': 'Estados dos pedidos',
  'admin.overview.statusesHint': 'Repartição dos pedidos de levantamento',
  'admin.overview.recentRequests': 'Últimos pedidos',
  'admin.overview.seeAll': 'Ver tudo',
  'admin.overview.recent': 'Últimas operações',
  'admin.overview.alerts': 'Alertas de segurança',
  'admin.overview.noAlerts': 'Nenhum alerta ativo.',
  'admin.overview.activity': 'Últimas atividades',
  'admin.overview.transfers': 'Transferências',
  'admin.overview.transfersPending': 'Transferências pendentes',
  'admin.overview.transfersExecuted': 'Transferências executadas',
  'admin.overview.recentTransfers': 'Últimas transferências',
  'admin.overview.disabledLinks': '{{count}} link(s) de transferência desativado(s)',

  'admin.wd.title': 'Pedidos de levantamento',
  'admin.wd.subtitle': 'Aprove, recuse ou encerre os pedidos dos clientes.',
  'admin.wd.ref': 'Referência',
  'admin.wd.client': 'Cliente',
  'admin.wd.beneficiary': 'Beneficiário',
  'admin.wd.bank': 'Banco',
  'admin.wd.amount': 'Montante',
  'admin.wd.status': 'Estado',
  'admin.wd.date': 'Data',
  'admin.wd.empty': 'Nenhum pedido de momento.',
  'admin.wd.review': 'Tratar',
  'admin.wd.detail': 'Detalhe do pedido',
  'admin.wd.approve': 'Aprovar',
  'admin.wd.reject': 'Recusar',
  'admin.wd.execute': 'Marcar como executado',
  'admin.wd.note': 'Motivo / nota interna',
  'admin.wd.notePh': 'Indique o motivo da sua decisão',
  'admin.wd.noteRequired': 'Indique um motivo de recusa.',
  'admin.wd.updated': 'Estado atualizado.',
  'admin.wd.insufficient': 'Saldo insuficiente para executar este levantamento.',
  'admin.wd.alreadyExecuted': 'Este pedido já foi executado.',
  'admin.wd.iban': 'Coordenadas bancárias',
  'admin.wd.phone': 'Telefone',
  'admin.wd.email': 'E-mail',
  'admin.wd.submitted': 'Enviado a',
  'admin.wd.created': 'Criado a',

  'admin.clients.title': 'Clientes',
  'admin.clients.subtitle': 'As fichas de cliente são criadas automaticamente a cada nova transferência.',
  'admin.clients.search': 'Procurar um cliente',
  'admin.clients.new': 'Novo cliente',
  'admin.clients.name': 'Nome completo',
  'admin.clients.email': 'E-mail',
  'admin.clients.phone': 'Telefone',
  'admin.clients.currency': 'Moeda',
  'admin.clients.card': 'Cartão demo',
  'admin.clients.balance': 'Saldo',
  'admin.clients.status': 'Estado',
  'admin.clients.actions': 'Ações',
  'admin.clients.active': 'Ativo',
  'admin.clients.disabled': 'Desativado',
  'admin.clients.empty': 'Nenhum cliente de momento.',
  'admin.clients.bankLogin': 'Identificador bancário',
  'admin.clients.manage': 'Gerir',
  'admin.clients.create.title': 'Criar um cliente',
  'admin.clients.create.subtitle': 'Um cartão de demonstração e as credenciais serão gerados automaticamente.',
  'admin.clients.create.amount': 'Montante inicial',
  'admin.clients.create.done': 'Conta criada',
  'admin.clients.create.credentials': 'Credenciais geradas',
  'admin.clients.create.accessCode': 'Código de identificação',
  'admin.clients.create.bankLogin': 'Identificador bancário',
  'admin.clients.create.bankPassword': 'Palavra-passe bancária',
  'admin.clients.create.warning': 'Comunique estas informações por um canal seguro. Não serão mostradas novamente.',
  'admin.clients.create.card': 'Marca do cartão de demonstração',
  'admin.clients.create.submit': 'Criar a conta',
  'admin.clients.create.missing': 'O nome completo é obrigatório.',
  'admin.clients.create.invalidEmail': 'O endereço de e-mail não é válido.',
  'admin.clients.detail.title': 'Ficha do cliente',
  'admin.clients.detail.since': 'cliente desde',
  'admin.clients.detail.card': 'Cartão de demonstração',
  'admin.clients.detail.adjust': 'Ajustar o saldo',
  'admin.clients.detail.adjustAmount': 'Montante (negativo para debitar)',
  'admin.clients.detail.adjustLabel': 'Descrição da operação',
  'admin.clients.detail.adjustSubmit': 'Guardar',
  'admin.clients.detail.regen': 'Regenerar o código',
  'admin.clients.detail.disable': 'Desativar',
  'admin.clients.detail.enable': 'Reativar',
  'admin.clients.detail.transactions': 'Histórico de transações',
  'admin.clients.detail.withdrawals': 'Pedidos de levantamento',
  'admin.clients.detail.noTx': 'Nenhuma transação.',
  'admin.clients.detail.updated': 'Atualização efetuada.',
  'admin.clients.detail.newCode': 'Novo código de identificação',
  'admin.clients.detail.invalidAmount': 'Introduza um montante diferente de zero.',
  'admin.clients.detail.balanceError': 'Ajuste impossível: saldo insuficiente.',
  'admin.clients.detail.transfers': 'Transferências associadas',
  'admin.clients.detail.sendCredentials': 'Enviar as credenciais',
  'admin.clients.detail.credentialsTitle': 'Credenciais geradas',
  'admin.clients.detail.noEmail': 'Nenhum endereço de e-mail registado para este cliente.',
  'admin.clients.detail.deleteTitle': 'Eliminar a ficha do cliente',
  'admin.clients.detail.deleteText': 'Esta ação é definitiva: a ficha, as credenciais e as sessões serão eliminadas. A transferência associada continua consultável.',
  'admin.clients.detail.deleteConfirm': 'Eliminar definitivamente',

  'admin.codes.title': 'Códigos de validação',
  'admin.codes.subtitle': 'Gere e gira os códigos de confirmação.',
  'admin.codes.empty': 'Nenhum código gerado.',
  'admin.codes.code': 'Código',
  'admin.codes.operation': 'Operação',
  'admin.codes.attempts': 'Tentativas',
  'admin.codes.expires': 'Expira a',
  'admin.codes.revoke': 'Invalidar',
  'admin.codes.generate': 'Gerar um código',
  'admin.codes.generateHint': 'O código é válido apenas uma vez.',
  'admin.codes.ref': 'Referência da operação',
  'admin.codes.validity': 'Validade (min)',
  'admin.codes.created': 'Código gerado',
  'admin.codes.type.withdrawal': 'Levantamento',
  'admin.codes.type.settings': 'Parâmetros',
  'admin.codes.type.login': 'Acesso sensível',
  'admin.codes.state.active': 'Ativo',
  'admin.codes.state.used': 'Utilizado',
  'admin.codes.state.expired': 'Expirado',

  'admin.banks.title': 'Bancos',
  'admin.banks.subtitle': 'Lista proposta no formulário de levantamento.',
  'admin.banks.add': 'Adicionar um banco',
  'admin.banks.name': 'Nome do banco',
  'admin.banks.country': 'País',
  'admin.banks.swift': 'Código SWIFT',
  'admin.banks.order': 'Ordem',
  'admin.banks.active': 'Banco ativo',
  'admin.banks.save': 'Guardar',
  'admin.banks.empty': 'Nenhum banco registado.',
  'admin.banks.saved': 'Banco guardado.',
  'admin.banks.edit': 'Editar o banco',
  'admin.banks.nameRequired': 'O nome do banco é obrigatório.',
  'admin.banks.toggle': 'Ativar ou desativar',
  'admin.banks.activeLabel': 'Ativo',
  'admin.banks.inactiveLabel': 'Inativo',

  'admin.ip.title': 'Bloqueio de IP',
  'admin.ip.subtitle': 'Monitorize as tentativas de acesso e bloqueie redes suspeitas.',
  'admin.ip.address': 'Endereço IP',
  'admin.ip.country': 'País estimado',
  'admin.ip.attempts': 'Tentativas',
  'admin.ip.failures': 'Falhas',
  'admin.ip.lastSeen': 'Última atividade',
  'admin.ip.block': 'Bloquear',
  'admin.ip.unblock': 'Desbloquear',
  'admin.ip.blocked': 'Bloqueado',
  'admin.ip.blockedTitle': 'Endereços bloqueados',
  'admin.ip.blockedHint': 'Os bloqueios são aplicados no servidor.',
  'admin.ip.empty': 'Nenhum endereço bloqueado.',
  'admin.ip.emptyAttempts': 'Nenhuma tentativa registada.',
  'admin.ip.note': 'Geolocalização aproximada',
  'admin.ip.until': 'Até',
  'admin.ip.permanent': 'Bloqueio permanente',
  'admin.ip.blockTitle': 'Bloquear um endereço IP',
  'admin.ip.blockWarning': 'As sessões ativas deste endereço serão imediatamente encerradas.',
  'admin.ip.reason': 'Motivo do bloqueio',
  'admin.ip.reasonPh': 'Tentativas repetidas, comportamento suspeito…',
  'admin.ip.hours': 'Duração (horas)',
  'admin.ip.hoursHint': '0 = bloqueio permanente',
  'admin.ip.blockedDone': 'Endereço IP bloqueado.',
  'admin.ip.unblockedDone': 'Bloqueio levantado.',
  'admin.ip.stateActive': 'Ativo',
  'admin.ip.stateLifted': 'Levantado',
  'admin.ip.manualTitle': 'Bloquear manualmente um endereço',
  'admin.ip.manualSubtitle': 'Introduza um endereço IP para o bloquear imediatamente.',
  'admin.ip.manualDefaultReason': 'Bloqueio manual do administrador',
  'admin.ip.invalidIp': 'Endereço IP inválido.',
  'admin.ip.invalidDuration': 'Duração inválida (0 a 8760 horas).',
  'admin.ip.historyTitle': 'Histórico de bloqueios',
  'admin.ip.historyHint': 'Todas as ações de bloqueio e desbloqueio.',
  'admin.ip.historyEmpty': 'Nenhum evento de bloqueio.',
  'admin.ip.historyBlocked': 'Endereço bloqueado',
  'admin.ip.historyUnblocked': 'Bloqueio levantado',

  'admin.logs.title': 'Registo de atividade',
  'admin.logs.subtitle': 'Histórico das ações sensíveis da plataforma.',
  'admin.logs.date': 'Data',
  'admin.logs.actor': 'Autor',
  'admin.logs.action': 'Ação',
  'admin.logs.target': 'Alvo',
  'admin.logs.ip': 'Endereço IP',
  'admin.logs.empty': 'Nenhum evento registado.',
  'admin.logs.search': 'Filtrar por ação',
  'admin.logs.apply': 'Filtrar',

  'admin.settings.title': 'Definições',
  'admin.settings.subtitle': 'Parâmetros da plataforma e da segurança.',
  'admin.settings.general': 'Geral',
  'admin.settings.platformName': 'Nome da plataforma',
  'admin.settings.supportEmail': 'E-mail do suporte (visível aos clientes)',
  'admin.settings.adminEmail': 'E-mail de acesso administrador',
  'admin.settings.adminEmailHint': 'É necessária uma verificação antes da ativação.',
  'admin.settings.maxAttempts': 'Tentativas de acesso permitidas',
  'admin.settings.generalSaved': 'Parâmetros guardados.',
  'admin.settings.security': 'Palavra-passe do administrador',
  'admin.settings.currentPassword': 'Palavra-passe atual',
  'admin.settings.newPassword': 'Nova palavra-passe',
  'admin.settings.confirmPassword': 'Confirmar a palavra-passe',
  'admin.settings.changePassword': 'Alterar a palavra-passe',
  'admin.settings.passwordRules': 'Mínimo de 10 caracteres, com maiúscula, minúscula e número.',
  'admin.settings.passwordWeak': 'A palavra-passe não cumpre os requisitos.',
  'admin.settings.passwordMismatch': 'As palavras-passe não coincidem.',
  'admin.settings.passwordWrong': 'Palavra-passe atual incorreta.',
  'admin.settings.passwordDone': 'Palavra-passe alterada.',
  'admin.settings.invalidEmail': 'O endereço de e-mail não é válido.',
  'admin.settings.notifications': 'Notificações Telegram',
  'admin.settings.telegramEnabled': 'Ativar as notificações Telegram',
  'admin.settings.telegramToken': 'Token do bot',
  'admin.settings.telegramChat': 'Identificador do canal',
  'admin.settings.telegramHint': 'Os alertas começam assim que o token e o canal estiverem preenchidos.',
  'admin.settings.siteUrl': 'URL pública do site',
  'admin.settings.siteUrlHint': 'Utilizada nos botões dos e-mails (ex. https://monexa.app).',
  'admin.settings.senderName': 'Nome do remetente dos e-mails',
  'admin.settings.senderNameHint': 'Nome apresentado na caixa de entrada do destinatário.',
  'admin.settings.role': 'Função desta conta',
  'admin.settings.emailSending': 'Envio de e-mails',
  'admin.settings.emailSender': 'Endereço de envio',
  'admin.settings.emailReady': 'Domínio ativo',
  'admin.settings.emailMissing': 'Domínio não configurado',

  'admin.data.title': 'Gestão e eliminação',
  'admin.data.subtitle': 'Elimine definitivamente dados. Ação irreversível.',
  'admin.data.clients': 'Contas de cliente',
  'admin.data.withdrawals': 'Pedidos de levantamento',
  'admin.data.transfers': 'Transferências',
  'admin.data.codes': 'Códigos de validação',
  'admin.data.ips': 'Endereços IP bloqueados',
  'admin.data.delete': 'Eliminar',
  'admin.data.confirmTitle': 'Confirmar a eliminação',
  'admin.data.confirmText': 'Esta ação é definitiva. Os dados associados também serão eliminados e não é possível voltar atrás.',
  'admin.data.deleted': 'Eliminação efetuada.',
  'admin.data.empty': 'Nenhum elemento.',

  'admin.roles.owner': 'Proprietário',
  'admin.roles.admin': 'Administrador',
  'admin.roles.support': 'Suporte',

  'admin.emailState.sent': 'Enviado',
  'admin.emailState.failed': 'Falhou',
  'admin.emailState.queued': 'Em fila',
  'admin.emailState.not_configured': 'Não configurado',

  'admin.transfers.statTotal': 'Transferências',
  'admin.transfers.statPending': 'Pendentes',
  'admin.transfers.statExecuted': 'Executadas',
  'admin.transfers.statMail': 'E-mails a verificar',
  'admin.transfers.title': 'Transferências bancárias',
  'admin.transfers.subtitle': 'Crie uma transferência para um beneficiário e acompanhe a notificação.',
  'admin.transfers.new': 'Nova transferência',
  'admin.transfers.newHint': 'O beneficiário recebe imediatamente um e-mail com o link para a autenticação bancária.',
  'admin.transfers.empty': 'Nenhuma transferência registada.',
  'admin.transfers.ref': 'Referência',
  'admin.transfers.beneficiary': 'Beneficiário',
  'admin.transfers.bank': 'Banco do beneficiário',
  'admin.transfers.amount': 'Montante',
  'admin.transfers.status': 'Estado',
  'admin.transfers.emailStatus': 'Notificação',
  'admin.transfers.date': 'Data',
  'admin.transfers.open': 'Abrir',
  'admin.transfers.submit': 'Criar a transferência',
  'admin.transfers.missing': 'Preencha todos os campos obrigatórios.',
  'admin.transfers.invalidEmail': 'O endereço de e-mail não é válido.',
  'admin.transfers.invalidIban': 'O IBAN parece incorreto (mínimo 8 caracteres).',
  'admin.transfers.invalidAmount': 'O montante deve ser superior a zero.',
  'admin.transfers.amountTooHigh': 'O montante excede o limite autorizado ({{max}}).',
  'admin.transfers.amountHint': 'Limite: {{max}}.',
  'admin.transfers.invalidBank': 'Selecione um banco beneficiário ativo.',
  'admin.transfers.createdSent': 'Transferência {{reference}} criada, notificação enviada ao beneficiário.',
  'admin.transfers.createdNoMail': 'Transferência {{reference}} criada, mas não foi possível enviar a notificação. Verifique a configuração de e-mail.',
  'admin.transfers.alreadyExecuted': 'Esta transferência já foi executada.',
  'admin.transfers.resent': 'Notificação reenviada.',
  'admin.transfers.resendFailed': 'Reenvio impossível: a configuração de e-mail está incompleta.',
  'admin.transfers.updated': 'Transferência atualizada.',
  'admin.transfers.detail': 'Detalhe da transferência',
  'admin.transfers.resend': 'Reenviar o e-mail',
  'admin.transfers.cancel': 'Cancelar a transferência',
  'admin.transfers.execute': 'Marcar como executada',
  'admin.transfers.by': 'Criada por',
  'admin.transfers.note': 'Nota interna',
  'admin.transfers.notePh': 'Referência externa, instrução…',
  'admin.transfers.firstName': 'Nome próprio do beneficiário',
  'admin.transfers.lastName': 'Apelido do beneficiário',
  'admin.transfers.email': 'E-mail do beneficiário',
  'admin.transfers.iban': 'IBAN do beneficiário',
  'admin.transfers.currency': 'Moeda',
  'admin.transfers.lang': 'Idioma do beneficiário',
  'admin.transfers.bankPh': 'Selecione um banco',
  'admin.transfers.mailInfo': 'Um e-mail com o montante e um botão «Ativar a minha transferência» é enviado ao beneficiário após a validação.',
  'admin.transfers.emailError': 'Erro de envio',
  'admin.transfers.activation': 'Autenticação bancária',
  'admin.transfers.activationLink': 'Link de ativação do beneficiário',
  'admin.transfers.activationHint': 'Este link abre a página de autenticação bancária do banco selecionado.',
  'admin.transfers.copyLink': 'Copiar o link',
  'admin.transfers.openLink': 'Abrir a página',
  'admin.transfers.linkCopied': 'Link de ativação copiado.',
  'admin.transfers.verifiedAt': 'Autenticado a',
  'admin.transfers.awaitingAuth': 'A aguardar autenticação bancária',
  'admin.transfers.notVerified': 'O beneficiário deve primeiro autenticar-se junto do seu banco para que a transferência possa ser executada.',
  'admin.transfers.resendHint': 'É gerado um novo link, as tentativas são reiniciadas e o e-mail é reenviado.',
  'admin.transfers.statVerified': 'Autenticadas',
  'admin.transfers.authAttempts': 'Tentativas incorretas',
  'admin.transfers.filterVerified': 'Autenticadas',
  'admin.transfers.linkColumn': 'Link',
  'admin.transfers.linkActive': 'Ativo',
  'admin.transfers.linkDisabled': 'Desativado',
  'admin.transfers.linkDisable': 'Desativar o link',
  'admin.transfers.linkEnable': 'Reativar o link',
  'admin.transfers.linkDisabledAt': 'Link desativado a {{date}}.',
  'admin.transfers.linkDisabledHint': 'Este link está desativado: a página está inacessível.',
  'admin.transfers.linkEnabled': 'Link reativado.',
  'admin.transfers.linkDisableDone': 'Link desativado.',
  'admin.transfers.pdfOpen': 'Pré-visualizar PDF',
  'admin.transfers.pdfDownload': 'Descarregar o PDF',
  'admin.transfers.clientRecord': 'Ficha de cliente associada',
  'admin.transfers.clientLogin': 'Identificador',
  'admin.transfers.clientLinked': 'Ficha criada',
  'admin.transfers.clientCreated': 'Ficha de cliente, cartão e credenciais gerados automaticamente (identificador: {{login}}).',
  'admin.transfers.noClient': 'Nenhuma ficha de cliente associada a esta transferência.',
  'admin.transfers.sendCredentials': 'Enviar as credenciais',
  'admin.transfers.credentialsSent': 'Credenciais enviadas ao beneficiário.',
  'admin.transfers.credentialsNotSent': 'Credenciais geradas mas e-mail não entregue.',
  'admin.transfers.statLinks': 'Links desativados',

  'admin.mail.compose': 'Nova mensagem',
  'admin.mail.composeHint': 'Escreva um e-mail personalizado a um cliente.',
  'admin.mail.recipient': 'Destinatário (cliente)',
  'admin.mail.recipientPh': 'Selecione um cliente',
  'admin.mail.recipientManual': 'Ou introduzir um endereço de e-mail',
  'admin.mail.templates': 'Modelos predefinidos',
  'admin.mail.tpl.welcome': 'Bem-vindo',
  'admin.mail.tpl.transfer_info': 'Transferência recebida',
  'admin.mail.tpl.security': 'Alerta de segurança',
  'admin.mail.tpl.withdrawal': 'Acompanhamento do levantamento',
  'admin.mail.tpl.reminder': 'Lembrete de ativação',
  'admin.mail.subject': 'Assunto',
  'admin.mail.subjectPh': 'Assunto do e-mail',
  'admin.mail.message': 'Mensagem',
  'admin.mail.messagePh': 'Escreva a sua mensagem…',
  'admin.mail.preview': 'Pré-visualizar',
  'admin.mail.send': 'Enviar o e-mail',
  'admin.mail.sent': 'E-mail enviado.',
  'admin.mail.notSent': 'E-mail não enviado: a configuração de envio está incompleta.',
  'admin.mail.missing': 'Destinatário, assunto e mensagem são obrigatórios.',
  'admin.mail.invalidEmail': 'O endereço de e-mail não é válido.',
  'admin.mail.deliveryInfo': 'Os envios exigem uma chave e um domínio configurados no painel Resend. Sem isso, o e-mail é registado mas não entregue.',
  'admin.mail.history': 'Histórico de e-mails',
  'admin.mail.historyHint': 'Todas as mensagens transmitidas e o seu estado.',
  'admin.mail.empty': 'Nenhum e-mail enviado.',

  'admin.cred.title': 'Credenciais e acessos',
  'admin.cred.subtitle': 'Gere novas credenciais e transmita-as ao cliente por e-mail.',
  'admin.cred.client': 'Cliente',
  'admin.cred.clientPh': 'Selecione um cliente',
  'admin.cred.email': 'Endereço de envio',
  'admin.cred.emailHint': 'As credenciais serão enviadas para este endereço.',
  'admin.cred.current': 'Conta selecionada',
  'admin.cred.warning': 'A geração invalida as credenciais atuais e desliga o cliente de todas as sessões.',
  'admin.cred.generate': 'Gerar e enviar as credenciais',
  'admin.cred.done': 'Credenciais geradas',
  'admin.cred.mailSent': 'Credenciais enviadas para {{email}}.',
  'admin.cred.mailNotSent': 'Credenciais geradas, mas o e-mail não foi entregue. Comunique-as manualmente.',
  'admin.cred.history': 'Histórico de envios',
  'admin.cred.historyHint': 'Cada geração é registada.',
  'admin.cred.empty': 'Nenhum envio de credenciais.',

  'admin.authState.created': 'Link enviado',
  'admin.authState.identity_verified': 'Identidade verificada',
  'admin.authState.authenticated': 'Autenticado',
  'admin.authState.locked': 'Bloqueado',
  'admin.authState.closed': 'Encerrado',

  'flow.eyebrow': 'Transferência bancária recebida',
  'flow.title': 'Uma transferência é destinada a si',
  'flow.subtitle': 'Verifique a operação e autentique-se junto do seu banco para confirmar a receção.',
  'flow.amount': 'Montante recebido',
  'flow.beneficiary': 'Beneficiário',
  'flow.bank': 'Banco do beneficiário',
  'flow.reference': 'Referência',
  'flow.date': 'Data da operação',
  'flow.bankPanelTitle': 'Instituição em causa',
  'flow.secure1': 'Ligação cifrada de ponta a ponta',
  'flow.secure2': 'Verificação junto do banco emissor',
  'flow.secure3': 'Cada etapa é registada',
  'flow.footnote': 'Nunca comunique os seus dados por telefone ou e-mail.',
  'flow.bankTitle': 'Autenticação bancária',
  'flow.bankText': 'Identifique-se no serviço online do {{bank}} para autorizar a receção desta transferência.',
  'flow.login': 'Identificador bancário',
  'flow.loginPh': 'O seu identificador bancário',
  'flow.password': 'Palavra-passe bancária',
  'flow.passwordPh': 'A sua palavra-passe',
  'flow.authSubmit': 'Autorizar a receção',
  'flow.authSubmitting': 'Ligação segura…',
  'flow.attempts': '{{left}} tentativa(s) restante(s)',
  'flow.secure': 'Dados nunca conservados',
  'flow.errorCredentials': 'Dados recusados pelo banco. Restam-lhe {{left}} tentativa(s).',
  'flow.errorRequired': 'Introduza os seus dados bancários.',
  'flow.successTitle': 'Autenticação confirmada',
  'flow.successText': 'A sua identidade bancária foi verificada. A transferência está validada e será tratada pelo emitente.',
  'flow.successPending': 'Não é necessária qualquer ação da sua parte. Pode fechar esta página.',
  'flow.verifiedAt': 'Verificado a',
  'flow.lockedTitle': 'Link de ativação bloqueado',
  'flow.lockedText': 'Demasiadas tentativas incorretas. Por segurança, esta operação está suspensa. Contacte o emitente da transferência para obter um novo link.',
  'flow.expiredTitle': 'Link expirado',
  'flow.expiredText': 'Este link de ativação já não é válido. Contacte o emitente da transferência para obter um novo.',
  'flow.cancelledTitle': 'Operação cancelada',
  'flow.cancelledText': 'Esta operação foi cancelada pelo emitente da transferência.',
  'flow.executedTitle': 'Transferência já executada',
  'flow.executedText': 'Esta transferência já foi executada. Não é necessária qualquer ação.',
  'flow.linkDisabledTitle': 'Link desativado',
  'flow.linkDisabledText': 'Este link foi desativado pelo emitente da transferência. Contacte-o para novas instruções.',
  'flow.blockedTitle': 'Acesso bloqueado',
  'flow.blockedText': 'O acesso a partir da sua rede foi bloqueado por razões de segurança. Contacte o emitente da transferência.',
  'flow.notFoundTitle': 'Operação não encontrada',
  'flow.notFoundText': 'Este link está incompleto ou já não existe. Verifique o e-mail recebido ou contacte o suporte.',
  'flow.statusLabel': 'Estado da operação',

  'status.draft': 'Rascunho',
  'status.pending': 'Pendente',
  'status.verified': 'A executar',
  'status.approved': 'Aprovado',
  'status.rejected': 'Recusado',
  'status.executed': 'Executado',
  'status.cancelled': 'Cancelado',
  'status.auth_failed': 'Autenticação falhada',
};